// src/state.js
import { atom } from 'recoil';
export const settingsState = atom({
    key: 'settingsState',
    default: {
        logo: { asset: { url: "" } },
        mainColor: "#888888",
        footer: []
    },
});